export const filterHtmlTags = (str: string) => (str || '').replace(/<\/?[^>]+(>|$)/g, '');
